import { __awaiter } from "tslib";
import { keymap as proseKeymap } from 'prosemirror-keymap';
import { createSlice } from '../context';
import { marksCtx, nodesCtx, schemaCtx, SchemaReady } from '../internal-plugin';
import { createTimer } from '../timing';
import { getAtom } from '../utility';
import { commandsCtx, CommandsReady } from './commands';
export const keymapCtx = createSlice([], 'keymap');
export const keymapTimerCtx = createSlice([], 'keymapTimer');
export const KeymapReady = createTimer('KeymapReady');
export const keymap = (pre) => {
    pre.inject(keymapCtx).inject(keymapTimerCtx, [SchemaReady, CommandsReady]).record(KeymapReady);
    return (ctx) => __awaiter(void 0, void 0, void 0, function* () {
        yield ctx.waitTimers(keymapTimerCtx);
        const nodes = ctx.get(nodesCtx);
        const marks = ctx.get(marksCtx);
        const schema = ctx.get(schemaCtx);
        const commandManager = ctx.get(commandsCtx);
        const getKeymap = (atoms, isNode) => atoms
            .map((x) => [getAtom(x.id, schema, isNode), x.keymap])
            .map(([atom, keymap]) => atom && (keymap === null || keymap === void 0 ? void 0 : keymap(atom, schema, commandManager.get)))
            .filter((x) => !!x)
            .map(proseKeymap);
        const nodesKeymap = getKeymap(nodes, true);
        const marksKeymap = getKeymap(marks, false);
        const keymapList = [...nodesKeymap, ...marksKeymap];
        ctx.set(keymapCtx, keymapList);
        ctx.done(KeymapReady);
    });
};
//# sourceMappingURL=keymap.js.map